var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16349",
    "data-name": "Group 16349",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 29.5,
    cy: 29.5,
    r: 29.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_2_-_Outline",
    "data-name": "Ellipse 2 - Outline",
    d: "M29.5,0A29.5,29.5,0,1,0,59,29.5,29.5,29.5,0,0,0,29.5,0m0-3A32.491,32.491,0,0,1,52.481,52.481,32.5,32.5,0,1,1,16.849-.445,32.3,32.3,0,0,1,29.5-3Z",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16360",
    "data-name": "Group 16360",
    transform: "translate(16.985 14.985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12036",
    "data-name": "Path 12036",
    d: "M8.322,3.5h7.884V1.314a1.314,1.314,0,0,1,2.628,0V3.5h2.19a3.507,3.507,0,0,1,3.5,3.5V24.527a3.507,3.507,0,0,1-3.5,3.5H3.5a3.507,3.507,0,0,1-3.5-3.5V7.008A3.507,3.507,0,0,1,3.5,3.5h2.19V1.314a1.314,1.314,0,0,1,2.628,0ZM2.628,24.527A.875.875,0,0,0,3.5,25.4H21.023a.875.875,0,0,0,.876-.876V10.512H2.628Z",
    fill: "#1a00e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12037",
    "data-name": "Path 12037",
    d: "M0,0H28.031V28.031H0Z",
    fill: "none"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.f3df29fe85e3a059c3badd9bda5e11a0.svg";
export { ForwardRef as ReactComponent };